import { CaretDownOutlined } from '@ant-design/icons';
import { Button, Collapse, Row, Col, Typography, Spin, Tooltip, Tabs} from 'antd';
import { EditIcon, InfoIcon, LoadingIcon } from 'components/Icons';
import TableContainer from 'components/TableContainer';
import Vocabulary from 'components/Vocabulary';
import _ from 'lodash'
import React, { useCallback, useMemo, useState } from 'react'
import ModalUtil from 'utils/modalUtil';
import { CellRenderers, columnRenderArrayData, getFilterProps, Sorters } from 'utils/tableUtils';
import { generateOperationalStatusColumn } from '../common';
import {ToggleButton} from '../IntegrationsTable';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { PermissionSetMap } from 'constants/RBACConstants';
import AuthorisedContainer from 'components/AuthorisedContainer';
import message from "components/CustomMessage";
import AppLoader from 'components/AppLoader';
import JiraMappingForm, { serviceNowVulnerableResponseIssueTypeOptions } from './JiraMappingForm';
import JiraLoginConfigForm from './JiraLoginConfigForm';
import ActionMenuV2 from 'components/ActionMenuV2';
import TicketTemplateForm from '../TicketTemplateForm';
import ServiceNowLoginConfigForm from '../serviceNow/ServiceNowLoginConfigForm';
import VersionOneMappingForm from '../VersionOne/VersionOneMappingForm';
import VersionOneConfigForm from '../VersionOne/VersionOneConfigForm';
import AzureBoardMappingForm from '../azureBoard/AzureBoardMappingForm';
import RallyLoginConfigForm from '../Rally/RallyLoginConfigForm';
import { isEmpty } from 'utils/lodashUtils';
import FreshServiceMappingForm from '../FreshService/FreshServiceMappingForm';
import { SyncCMDBResourceButton, useCmdbSupportedIntegrations, useTemplateSupportedIntegrations } from '../genericIntegrationTicketUtils';
import { useFeatureFlag } from 'contexts/FeatureFlagContext';
import ServiceNowCmdbMappingForm, { ServiceNowCmdbConfigListingTable } from '../serviceNow/ServiceNowCmdbListing';
import useUrlFilters from 'hooks/useUrlFilters';
import ZenDeskConfigMappingForm from '../Zendesk/ZenDeskConfigMappingForm';
import JiraCMDBMappingForm from '../JiraCMDB/JiraCMDBMappingForm';
import JiraCMDBConfigListing from '../JiraCMDB/JiraCMDBConfigListing';
import { useJiraCMDBData } from '../JiraCMDB/JiraCMDBUtils';

const Text = Typography.Text;

export const toolsUsingValueFromCustomFields = ["GitLab Issues", "Rally", "Version One"];

export const getDataIndex = (dataIndex, data, key) => {
  if(data){
    const itemIndex = _.findIndex(data[0]?.customFields, field => field.key === key);
    return itemIndex !== -1 ? `customFields[${itemIndex}].name` : dataIndex;
  }
}

export default function JiraListingNew({ loginConfigList, data, loading, ...restProps }) {
    const configuredList = [] ,unConfiguredList = [];
    const refArr = _.isEmpty(data) ? [] : data.map(config => config.loginConfigId);

    const showSyncButton = restProps.name === "Service Now" || restProps.name === "Jira";

    if(!_.isEmpty(loginConfigList)){
      for(const loginConfig of loginConfigList){
        if(refArr.includes(loginConfig.id)) {
          configuredList.push(loginConfig)
        }else{
          unConfiguredList.push(loginConfig)
        }
      }
    }
    return <>
          {
          showSyncButton &&
          <SyncCMDBResourceButton toolName={restProps.name} isDisabled={isEmpty(loginConfigList)}/>
          } 
            <Spin spinning={loading} indicator={<AppLoader />}>{[...configuredList, ...unConfiguredList].map((loginConfig, i) => <ConfigItem loginConfig={loginConfig} data={data} key={i} index={i} {...restProps} />)}</Spin> 
          </>
}

function ConfigItem({loginConfig, data, index, ...restProps}){

  
    const urlFilters = useUrlFilters();

    let defaultActiveLoginConfigId = null;
    
    if(!isEmpty(urlFilters)){
      defaultActiveLoginConfigId = urlFilters.defaultActiveLoginConfigId;
    }

    const MappingFormComponent = restProps.name === "Version One" ? VersionOneMappingForm : restProps.name === "Azure Board" ? AzureBoardMappingForm : restProps.name === "FreshService" ? FreshServiceMappingForm : restProps.name === "Zendesk" ? ZenDeskConfigMappingForm : restProps.ConfigMappingForm || JiraMappingForm;
    const featureFlags = useFeatureFlag();
    const showServiceNowCmdbTab = restProps.name === "Service Now" && featureFlags.RBVM_ASSETS;
    const showJiraCmdbTab = restProps.name === "Jira" && featureFlags.RBVM_ASSETS;
    const [currentTab, setCurrentTab] = useState("itsm");
    const {jiraCMDBData, fetchData} = useJiraCMDBData({loginConfig});
    const cmdbSupportedTools = useCmdbSupportedIntegrations(restProps.name);

    const updateConfigComponent = useCallback(() => {
      if(currentTab === "cmdb" && cmdbSupportedTools.includes("Jira")){
        fetchData();
        return;
      }
      restProps.onUpdateConfigComponent();
    }, [cmdbSupportedTools, currentTab, fetchData, restProps]);

    const onAddMapping = useCallback(async (data) => { 
        const CMDBComponent = restProps.name === "Service Now" ? ServiceNowCmdbMappingForm : JiraCMDBMappingForm; 
        ModalUtil.show({
            content: currentTab === "itsm" ? <MappingFormComponent name={restProps.name} displayName={restProps.displayName} config={data} onUpdateConfigComponent={restProps.onUpdateConfigComponent} url={restProps.name === "GitLab Issues" && loginConfig?.url} loginConfigId={loginConfig.id} /> : <CMDBComponent data={data} loginConfigId={loginConfig?.id} onUpdateConfigComponent={updateConfigComponent}/>,
        })
    }, [loginConfig.id, restProps.onUpdateConfigComponent, updateConfigComponent, loginConfig?.url, restProps.name,restProps.displayName, currentTab]);

    const editConfig = useCallback(() => {
        let Component;
        if (restProps.name === 'Jira') {
          Component = JiraLoginConfigForm;
        } else if (restProps.name === 'Service Now') {
          Component = ServiceNowLoginConfigForm;
        } else if(restProps.name === "Version One"){
          Component = VersionOneConfigForm;
        } else if(restProps.name === "Rally"){
          Component = RallyLoginConfigForm;
        } 
        else {
          Component = restProps.ModalFormComponent;
        }

        ModalUtil.show({
            content: <Component displayName={restProps.displayName} name={restProps.name} config={loginConfig} onUpdateConfigComponent={restProps.onUpdateConfigComponent} />
        })
    }, [loginConfig, restProps.name, restProps.onUpdateConfigComponent, restProps.displayName, restProps.ModalFormComponent]);

    const onDelete = useCallback(async () => {
      try{
        const toolName = restProps.name.toUpperCase().replace(' ', '_');
        await ToolsIntegrationsAPI.deleteTicketSystemToolLoginDetails(toolName, loginConfig.id).promise;
        restProps.onUpdateConfigComponent();
        message.success("Configuration deleted successfully")
      }catch(err){
        console.log(err);
      }
    }, [loginConfig.id, restProps]);

    const CMDBData = useMemo(() => {
      let data = loginConfig.discoveryDetails || [];
      if(cmdbSupportedTools.includes("Jira")){
        data = jiraCMDBData;
      }
      return data;
  }, [cmdbSupportedTools, jiraCMDBData, loginConfig.discoveryDetails]);

    const selfData = data?.filter(config => config.loginConfigId === loginConfig.id) || [];
    const numberOfConfigs = selfData.length + CMDBData.length;
    const deleteMessage = selfData.length > 0 ? "Please delete the configurations of this account first" : "";
    const itsmTabText = "ITSM & VR";

    const defaultFilter = useMemo(() => {
        const productFilter = urlFilters.defaultProductFilter?.[0];
        const subProductFilter = urlFilters.defaultSubproductFilter?.[0];

        if (defaultActiveLoginConfigId && defaultActiveLoginConfigId[0] === loginConfig.id) {
          return {
            product: [productFilter], 
            subProduct: [subProductFilter]  
          };
        }
        else return {};
    }, [defaultActiveLoginConfigId, loginConfig.id, urlFilters.defaultProductFilter, urlFilters.defaultSubproductFilter]);

    const items = [{
      type: "edit",
      // for Asana, if login type is OAuth, then disable edit
      disabled: restProps.name === "Asana" && loginConfig.tokenType === "REQUEST_TOKEN",
    }, {
      type: "delete",
      permission: PermissionSetMap.DELETE_TOOL,
      tooltip: deleteMessage,
      disabled: selfData.length > 0
    }];
    const tempateSupportedIntegrations = useTemplateSupportedIntegrations();
    if(tempateSupportedIntegrations.indexOf(restProps.name) !== -1){
      items.unshift({
        type: "edit_template",
        icon: <EditIcon />,
        text: <>Edit Ticket Template<Tooltip title="Template will be applied to all configurations where the template has not been modified."><InfoIcon className="m-l-xs" /></Tooltip></>
      })
    }
    const onClick = async (_, record) => {
      switch(record.name){
        case "edit":
          editConfig()
          break;
        case "delete":
            await onDelete()
          break;
        case "edit_template":
            ModalUtil.show({
              content: <TicketTemplateForm isConfigLevel configId={loginConfig.id} />,
              afterClose: () => restProps.onUpdateConfigComponent(true)
            });
            break;
        default:
          break;
      }
    }
    const CMDBListingComponent = restProps.name === "Service Now" ? ServiceNowCmdbConfigListingTable : JiraCMDBConfigListing;
    return (
        <Collapse 
            className="pull-based-tool" 
            defaultActiveKey={defaultActiveLoginConfigId}
            bordered={false} 
            expandIconPosition="right"
            expandIcon={({isActive}) => <Tooltip title={isActive ? "Close Mapping" : "Open Mapping" }><CaretDownOutlined rotate={isActive ? 180 : 0} style={{ fontSize: 20 }} /></Tooltip>}
        >
            <Collapse.Panel key={loginConfig.id} header={panelHeader(loginConfig, numberOfConfigs )}>
                <div className="d-flex align-items-center justify-content-flex-end m-b-sm">
                   <AuthorisedContainer permission={PermissionSetMap.WRITE_TOOLS}>
                    <Button size="small" type="primary" onClick={() => onAddMapping()}>Add Mapping</Button>
                   </AuthorisedContainer>
                   <div className='m-l-sm'>
                      <ActionMenuV2 items={items} onClick={onClick} />
                   </div>
                </div>
                {
                showServiceNowCmdbTab || showJiraCmdbTab ?
                <Tabs defaultActiveKey="itsm" onChange={setCurrentTab}>
                  <Tabs.TabPane key={"itsm"} tab={`${itsmTabText} (${selfData.length})`}>
                    <Spin spinning={_.isUndefined(data)} indicator={<LoadingIcon />}><ConfigTable loginConfig={loginConfig} data={selfData} {...restProps} onEdit={onAddMapping} defaultFilter={defaultFilter} /></Spin>
                  </Tabs.TabPane>
                  <Tabs.TabPane key={"cmdb"} tab={`CMDB (${CMDBData.length})`}>
                    <CMDBListingComponent data={CMDBData} onEditConfig={onAddMapping} onUpdateConfigComponent={updateConfigComponent} loginConfigId={loginConfig.id}/>
                  </Tabs.TabPane>
                </Tabs>
                :
                <Spin spinning={_.isUndefined(data)} indicator={<LoadingIcon />}><ConfigTable loginConfig={loginConfig} data={selfData} defaultActiveLoginConfigId={defaultActiveLoginConfigId} defaultFilter={defaultFilter} {...restProps} onEdit={onAddMapping} /></Spin>
                }
            </Collapse.Panel>
        </Collapse>
    )
}

function ConfigTable({ data, loginConfig, enabledAPI, deleteAPI, onUpdateConfigComponent, onEdit, defaultActiveLoginConfigId, defaultFilter, ...restProps }) {
    const isAzureBoard = restProps.name === "Azure Board";

    const onDelete = async (record) => {
      try{
        if(deleteAPI){
          await deleteAPI(record.id).promise
          onUpdateConfigComponent(false);
          message.success('Configuration deleted successfully.');
        }
      }catch(err){
        console.log(err)
      }
    }
    const items = [{
      type: "edit",
    }, {
      type: "delete",
      permission: PermissionSetMap.DELETE_TOOL
    }]
    const tempateSupportedIntegrations = useTemplateSupportedIntegrations();
    if(tempateSupportedIntegrations.indexOf(restProps.name) !== -1){
      items.unshift({
        type: "edit_template",
        icon: <EditIcon />,
        text: "Edit Ticket Template"
      })
    }
    const onClick = async (_, record) => {
      switch(record.name){
        case "edit":
            let data = {...record.data}
            onEdit(data)
          break;
        case "edit_template":
            ModalUtil.show({
              content: <TicketTemplateForm configId={record.data.id} />,
              afterClose: () => onUpdateConfigComponent(false)
            })
          break;
        case "delete":
            await onDelete(record.data)
          break;
        default:
          break;
      }
    }

    const subProductFilters = _.uniqBy(data.flatMap((item) => item.subProductNameIds).map((sub) => ({ text: sub.name, value: sub.name })), "value");

    const productFilters = _.uniqBy(data.flatMap((item) => item.productNameId).map((product) => ({ text: product.name, value: product.name })), "value");



    const columns = [{
        title:"Config Type",
        dataIndex: "configurationType",
        render: _.capitalize,
        sorter: Sorters.STRING("configurationType"),
        ...getFilterProps({dataIndex: "configurationType", dataSource: data, filterLabelFormatter: (value) => _.capitalize(value)}),
        width: 130
      },{
        title: <Vocabulary name="product" />,
        dataIndex: "productNameId",
        ...getFilterProps({dataIndex: "productNameId", filters: productFilters, exactMatch: true}),
        render: (productNameId, record) => {
          // The product was moved to the archive, but its associated sub-product-level ticket configurations were not archived accordingly.
          // As a result, when the UI attempts to access these configs, the missing product reference (null) causes it to break.
          return !isEmpty(record.productNameId) ? columnRenderArrayData(_.map(_.compact(record.productNameId), (product) => product.name).join()) : <Text>All</Text>
        },
        width: 130,
        onFilter: (values, record) => record.productNameId.filter((product) => values.includes(product.name)).length > 0
      },{
        title: <Vocabulary name="subProduct" />,
        dataIndex: "subProductNameIds",
        ...getFilterProps({dataIndex: "subProductNameIds", filters: subProductFilters, exactMatch: true}),
        render: (subProductNameIds, record) => {
          return !isEmpty(record.subProductNameIds) ? columnRenderArrayData(_.map(_.compact(record.subProductNameIds), (subproduct) => subproduct.name).join()) : <Text>All</Text>
        },
        width: 130,
        onFilter: (values, record) => record.subProductNameIds.filter((sub) => values.includes(sub.name)).length > 0
      },
      ...(loginConfig.ticketSystemType === "RALLY") ? [{
        title: "Workspace",
        dataIndex:"organisation",
        render: (organisation, record) => {
          const workspace = _.find(record.customFields, field => field.key === "workspace");
          return toolsUsingValueFromCustomFields.includes(restProps.name) && !_.isEmpty(workspace) ? workspace.name : CellRenderers.VALUE_OR_NA(organisation);
        },
        width: 130,
        ellipsis: true,
        ...getFilterProps({dataIndex: getDataIndex("organisation", data, "workspace"), dataSource: data}),
      }] : [],
      ...(loginConfig.ticketSystemType === "ZENDESK" ? [] : [{
        title: loginConfig.ticketSystemType === "FRESHSERVICE" ? "Ticket Type" : loginConfig.ticketSystemType === "SERVICE_NOW" ? "Module" : "Project Key",
        dataIndex: "projectKey",
        render: (projectKey, record) => {
          const project = _.find(record.customFields, field => field.key === "projectValue");
          const projectKeyValue = loginConfig.ticketSystemType === "SERVICE_NOW" ? CellRenderers.VALUE_OR_NA(_.startCase(_.toLower(projectKey))) : CellRenderers.VALUE_OR_NA(projectKey);
          if(loginConfig.ticketSystemType === "ASANA" && !isEmpty(record.projectKeyNames)){
            return columnRenderArrayData(record.projectKeyNames.map((project) => project.name).join());
          }
          return toolsUsingValueFromCustomFields.includes(restProps.name) && !_.isEmpty(project) ? project.name : projectKeyValue;
        },
        ...getFilterProps({ dataIndex: getDataIndex("projectKey", data, "projectValue"), dataSource: data }),
        width: 130,
        sorter: Sorters.STRING(getDataIndex("projectKey", data, "projectValue")),
      }]),
      ...(loginConfig.ticketSystemType === "ZENDESK" || loginConfig.ticketSystemType === "ASANA" ? [{
        title: "Organisation",
        dataIndex: "organisationName",
        render: CellRenderers.VALUE_OR_NA,
        ...getFilterProps({ dataIndex: "organisationName", dataSource: data }),
        width: 130,
        sorter: Sorters.STRING("organisationName"),
      }] : []),
      ...(loginConfig.ticketSystemType === "ZENDESK" ? [{
        title: "Form",
        dataIndex: "formName",
        render: CellRenderers.VALUE_OR_NA,
        ...getFilterProps({ dataIndex: "formName", dataSource: data }),
        width: 130,
        sorter: Sorters.STRING("formName"),
      }] : []),
      ...(loginConfig.ticketSystemType === "VERSION_ONE" ? [{
        title: "Team",
        dataIndex:"team",
        width: 100,
        render: (team, record) => {
          const _team = record.customFields ? _.find(record.customFields, field => field.key === "teamValue")?.name : "";
          return CellRenderers.VALUE_OR_NA(_team);
        }
      }] 
      : 
      []),
      {
        title: loginConfig.ticketSystemType === "FRESHSERVICE" ? "Service Item" : "Issue Type",
        dataIndex: "issueType",
        width: 100,
        render: (issueType, record) => {
          if(loginConfig.ticketSystemType === "VERSION_ONE"){
            const _issueType = record.customFields ? _.find(record.customFields, field => field.key === "issueTypeValue")?.name : issueType;
            return CellRenderers.VALUE_OR_NA(_issueType);
          }
          if(record.projectKey === "Vulnerability Response"){
            return serviceNowVulnerableResponseIssueTypeOptions.find((option) => option.value === issueType)?.label;
          } 
          return CellRenderers.VALUE_OR_NA(issueType);
        }
      },
      ...(isAzureBoard ? [{
        title: "Area",
        dataIndex: "area",
        width: 100,
        render: (area) => CellRenderers.VALUE_OR_NA(_.split(area, '\\').reverse()[0])
      }] : []),
      generateOperationalStatusColumn(data, 130),
      {
        title:"Last Run",
        dataIndex: "lastConnected",
        sorter: Sorters.STRING("lastConnected"),
        render: CellRenderers.TIME,
        width: 130
      },{
        title: "Config",
        dataIndex: "enabled",
        sorter: Sorters.STRING("enabled"),
        render:(text,record)=>{
          return   <ToggleButton text={!text} record={record} integrationData={{enabledAPI}} onUpdateConfigComponent={onUpdateConfigComponent}/>
         },
        width: 80
     },{
        title: "Action",
        key: 'action',
        dataIndex: "id",
        width: 50,
        render: (id, obj) => {

          return (
            <ActionMenuV2 items={items} onClick={onClick} data={obj} />
        )
      },
    }]

    return ( 
        <TableContainer
            style={{ overflowY: 'hidden' }}
            columns={columns}
            dataSource={data}
            loading={_.isUndefined(data)}
            showSizeChanger={true}
            defaultFilter = {defaultFilter}
            locale={{ emptyText: "No configurations" }}
            enableScroll={true}
            defaultSort={{ column: "configurationType", order: "ascend" }}
        />
    )
}

export const panelHeader = (loginConfig, numberOfConfigs) => {
    const {url, name, userName, version} = loginConfig; 
    return (
        <Row className="align-items-center">
          <Col span={20}>
            {url && <Typography.Text className="m-r-l">URL: {url}</Typography.Text>}
            {name && <Typography.Text className="m-r-l">Name: {name}</Typography.Text>}
            {userName && <Typography.Text className="m-r-l">UserName: {userName}</Typography.Text>}
            {version && <Typography.Text className="m-r-l">API Version: {version}</Typography.Text>}
            <Typography.Text className="m-r-l">{numberOfConfigs === 0 ? "No Configurations Available" :`Configurations: ${numberOfConfigs}`}</Typography.Text>
          </Col>
        </Row>
      )
}